<template>
    <button
        :disabled="loading || disabled"
        :class="{
            outline,
            fullWidth,
            red,
            redOutline,
            danger,
            disabled,
            transparent,
            loading,
            icon,
            inverse,
            'icon--right': icon && rightIcon,
            small
        }"
        @click="$emit('click')"
    >
        <div v-if="loading" class="loading-icon">
            <LoadingIcon />
        </div>
        <slot v-else></slot>
        <div
            v-if="icon.length > 0"
            class="icon"
            :class="{ 'icon--right': rightIcon }"
        >
            <svg-icon :iconName="icon" />
        </div>
    </button>
</template>

<script>
import LoadingIcon from "./LoadingIcon";

export default {
  name: "Button",
  components: {
    LoadingIcon
  },
  props: {
    outline: {
      type: Boolean,
      default: false
    },
    fullWidth: {
      type: Boolean,
      default: false
    },
    red: {
      type: Boolean,
      default: false
    },
    redOutline: {
      type: Boolean,
      default: false
    },
    danger: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    },
    transparent: {
      type: Boolean,
      default: false
    },
    loading: {
      type: Boolean,
      default: false
    },
    icon: {
      type: String,
      default: ""
    },
    rightIcon: {
      type: Boolean,
      default: false
    },
    small: {
      type: Boolean,
      default: false
    },
    inverse: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {};
  }
};
</script>

<style lang="scss" scoped>
@import "~@/style/_variables.scss";
$box-shadow: 0 0 0 2px;

button,
.selected {
    display: flex;
    font-weight: 600;
    font-size: $font-size-md;
    line-height: $font-size-md;
    color: $white;
    padding: $padding-md $padding-lg;
    background-color: $blue-navy;
    border: 2px solid $blue-navy;
    outline: 0;
    border-radius: $border-radius-md;
    cursor: pointer;
    box-shadow: 0 0 0 0px $blue-gray-dark;
    transition: $transition-simple-xtra-fast;
    position: relative;
    align-items: center;
    &.small {
        font-size: $font-size-sm;
        line-height: $font-size-sm;
    }

    &.icon {
        padding-left: 40px;
        padding-right: 14px;

        &--right {
            padding-left: 16px;
            padding-right: 40px;
        }
    }

    .icon {
        position: absolute;
        width: 22px;
        height: 22px;
        top: 50%;
        left: 10px;
        transform: translateY(-50%);

        .svg {
            color: $white;
            stroke: $white;
        }

        &--right {
            left: initial;
            right: 10px;
        }
    }

    &:hover,
    &:active {
        background-color: $blue-navy-dark;
    }

    &:focus,
    &:active {
        box-shadow: $box-shadow $blue-gray-dark;
    }

    &.outline {
        color: $blue-navy;
        background-color: $white;
        &:hover,
        &:active {
            color: $white;
            background-color: $blue-navy;
        }
    }

    &.fullWidth {
        width: 100%;
        justify-content: center;
    }

    &.red {
        border-color: $alt-red-active;
        background-color: $alt-red-active;
        color: $white;
        &:hover,
        &:active {
            background-color: $alt-red-dark;
            border-color: $alt-red-dark;
        }

        &:focus,
        &:active {
            box-shadow: $alt-red-dark;
        }
    }

    &.redOutline {
        border-color: $alt-red-active;
        color: $alt-red-active;
        background-color: $white;
        &:hover,
        &:active {
            background-color: $alt-red-active;
            color: $white;
        }

        &:focus,
        &:active {
            box-shadow: $alt-red-dark;
        }
    }

    &.navy {
        background-color: $dremca-navy;
        font-weight: 600;
        border-width: 0;
        transition: $transition-simple-fast;
        &:hover,
        &:active {
            background-color: $blue-navy;
        }

        &:focus,
        &:active {
            box-shadow: $alt-red-dark;
        }
    }

    &.danger {
        color: $red-active;
        background-color: $red-xtra-light;

        &:hover,
        &:active {
            color: $red-dark;
            background-color: $red-light;
        }

        &:focus,
        &:active {
            box-shadow: $box-shadow $red-light;
        }
    }

    &.disabled {
        color: $label-gray;
        background-color: $background-gray;
        cursor: not-allowed;
        border-color: $gray-dark;

        &:hover,
        &:active {
            color: $label-gray;
            background-color: $background-gray;
        }

        &:focus,
        &:active {
            box-shadow: 0 0 0 0px $blue-gray-dark;
        }

        &.inverse {
            background-color: $gray-dark;

            &:hover,
            &:active {
                background-color: $gray-dark;
            }
        }

        .icon {
            .svg {
                color: $label-gray;
                stroke: $label-gray;
            }
        }
    }

    &.transparent {
        border: none;
        background-color: $white;
        color: $blue-navy;
        &:hover,
        &:active {
            background-color: $blue-gray-light;
        }

        &:focus,
        &:active {
            background-color: $blue-gray-light;
        }
    }

    &.loading {
        cursor: wait;
        background-color: $alt-red-light;
        border-color: $alt-red-light;

        &:focus,
        &:active {
            box-shadow: 0 0 0 0px $blue-gray-dark;
        }
    }

    .loading-icon {
        height: $font-size-md;
        width: $font-size-md;
        position: relative;
        transform: scale(1.2);
    }
}
.menu-item {
    &:hover,
    &:active {
        button.navy {
            background-color: $blue-navy;
        }
    }
    &:active,
    &:focus {
        button.navy {
            box-shadow: $alt-red-dark;
        }
    }
}
</style>
